import { SessionChangedError } from '@scrambl/shared/session-scope'

import { useThreadAccessSession } from './useThreadAccessSession'

/** Persistent ownership stays separate from this access-generation lease.
 * A verified staff preview can read, but cannot adopt/send personal drafts. */
export function useThreadComposerSession() {
  const access = useThreadAccessSession(),
    owner = access.preview ? null : access.owner
  const enabled = access.enabled && !access.preview
  const assertCurrent = () => {
    access.assertCurrent()
    if (!enabled) throw new SessionChangedError()
  }
  return {
    owner,
    enabled,
    key: JSON.stringify([access.key, owner]),
    assertCurrent,
    isCurrent() {
      try {
        assertCurrent()
        return true
      } catch {
        return false
      }
    },
    async run<T>(
      signal: AbortSignal,
      action: (signal: AbortSignal) => Promise<T>,
    ): Promise<T> {
      assertCurrent()
      return access.run(signal, async linked => {
        assertCurrent()
        const result = await action(linked)
        assertCurrent()
        return result
      })
    },
  }
}
